import React from 'react';

import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Container from 'reactstrap/lib/Container';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';

import { ContentrArea, Video } from '@ttstr/components';

const ContactPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <article>
      <Helmet>
        <title>Klingeltöne</title>
        <body className="sozialticket-page" />
      </Helmet>
      <Container className="video-player-container d-flex p-0 mx-0 w-100">
        <Video
          preload="auto"
          muted // autoPlay only works in Safari when muted
          autoPlay
          disablePictureInPicture
          loop={true}
          playsInline
          nativeControls={false}
          controls
          controlColor="light"
          controlOutline
          controlsList="nodownload nofullscreen noremoteplayback"
          poster={require('./assets/images/vwl_klingelton_poster.png')}
          containerClassName="d-block sticky-top fold-behind"
          className="fullsize-video"
        >
          <source
            src="https://cdn.tickettoaster.de/von_wegen_lisbeth/VWL_Klingeltöne_Video_V5_16x9_komprimiert.mp4"
            type="video/mp4"
          />
        </Video>
      </Container>
      <Container className="list-page my-5">
        <h1 className="mb-5 text-center">KLINGELTÖNE</h1>
        <ContentrArea id="ringtone-page-content" />
      </Container>
    </article>
  );
};

export default React.memo(ContactPage);
